var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "right", trigger: "click" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "tabsStyleForm",
              staticClass: "demo-form-inline",
              attrs: {
                model: _vm.styleInfo,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.text_h_position") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: { change: _vm.styleChange },
                      model: {
                        value: _vm.styleInfo.horizontal,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "horizontal", $$v)
                        },
                        expression: "styleInfo.horizontal",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "left" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                      ]),
                      _c(
                        "el-radio-button",
                        {
                          attrs: {
                            disabled:
                              _vm.styleInfo.vertical === "center" &&
                              _vm.elementType !== "de-select-grid",
                            label: "center",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("chart.text_pos_center")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("el-radio-button", { attrs: { label: "right" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showVertical
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_v_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.styleChange },
                          model: {
                            value: _vm.styleInfo.vertical,
                            callback: function ($$v) {
                              _vm.$set(_vm.styleInfo, "vertical", $$v)
                            },
                            expression: "styleInfo.vertical",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "top" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_top"))),
                          ]),
                          _c(
                            "el-radio-button",
                            {
                              attrs: {
                                disabled: _vm.styleInfo.horizontal === "center",
                                label: "center",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("chart.text_pos_center")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("i", {
        staticClass: "iconfont icon-tabs",
        attrs: { slot: "reference" },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }